<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" v-loading="loading"  layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <wt-table :list="tableData" :labels="tableLabels">
        <template>
          <slot />
        </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-balance-manage-table'

export default {
  name: 'pt-balance-manage-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userBalance: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getBalanceList', page, next, size)
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    reload () {
      this.$refs.table.load()
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .balance-text {
    text-align: right;
    font-size: 22px;
    color: #606266;
    margin-top: .3rem;
    padding-bottom: .2rem;
    border-bottom: 1px solid #EDBE81;
  }

  .balance-color {
    color: #edbe81
  }
</style>
